import * as actionType from 'constants/action-constants';

const initialState = {
  isLoading: false,
  error: '',
  status: '',
  hotelList: null,
  contactSupportDetail: null,
  contactSupportEmailObj: null,
  publishReport: null,
};

const demandPartnersReducer = (state = initialState, action) => {
  switch (action.type) {
    // Reset error case.
    case actionType.RESET_ERROR:
      return {
        ...state,
        error: '',
      };

    // get demand partners hotel list cases.
    case actionType.GET_DEMAND_PARTNERS_HOTEL_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
      };
    case actionType.GET_DEMAND_PARTNERS_HOTEL_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: 'success',
        hotelList: action.payload ?? [],
      };
    case actionType.GET_DEMAND_PARTNERS_HOTEL_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        status: 'failure',
      };

    // get property publish status cases.
    case actionType.GET_PUBLISH_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
        publishReport: null,
      };
    case actionType.GET_PUBLISH_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: 'success',
        publishReport: action.payload,
      };
    case actionType.GET_PUBLISH_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
        status: 'failure',
      };

    // Get contact support cases.
    case actionType.GET_CONTACT_SUPPORT_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        contactSupportDetail: null,
      };
    case actionType.GET_CONTACT_SUPPORT_DETAIL_SUCCESS:
      return {
        ...state,
        contactSupportDetail: action.payload.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.GET_CONTACT_SUPPORT_DETAIL_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    // contact support email cases
    case actionType.SEND_CONTACT_SUPPORT_EMAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        contactSupportEmailObj: null,
      };
    case actionType.SEND_CONTACT_SUPPORT_EMAIL_SUCCESS:
      return {
        ...state,
        contactSupportEmailObj: action.payload.data,
        isLoading: false,
        status: 'success',
      };
    case actionType.SEND_CONTACT_SUPPORT_EMAIL_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };
    default:
      return state;
  }
};

export default demandPartnersReducer;
